enum MfaMode {
  MandatoryEnabled = 'mandatory_enabled',
  MandatoryDisabled = 'mandatory_disabled',
  OptionalEnabled = 'optional_enabled',
  OptionalDisabled = 'optional_disabled',
}

export default MfaMode;
